import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from '../nav';
import { VE_BANK_ASSETS } from '../lib/brand';
import { readPayment } from '../lib/transfer';
export function Success() {
  const navigate = useNavigate();
  const {
    pathname,
    search
  } = useLocation();
  const payment = readPayment(pathname + search);
  const [saved, setSaved] = useState(false);
  return <main className="flex h-full w-full flex-col bg-brand-cloud" data-id="element-693" data-mp="3h66aw21ryb9y">
      <section className="phone-scroll flex-1 overflow-y-auto px-5 pt-16 text-center" data-id="element-694" data-mp="3m4hjyak8whr4">
        <motion.div initial={{
        scale: 0.4,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 220,
        damping: 16
      }} className="relative mx-auto flex h-24 w-24 items-center justify-center rounded-[30px] bg-brand-success text-4xl text-white shadow-float" data-id="element-695" data-mp="3m6aw25dmnu6i">
          ✓
          <span className="absolute -bottom-3 -right-3 flex h-10 w-10 items-center justify-center rounded-xl bg-white p-1.5 shadow-soft" data-id="element-696" data-mp="21po3wse78hlj">
            <img src={VE_BANK_ASSETS.appIcon} alt="" className="h-full w-full object-contain" data-id="element-697" data-mp="1i41tj3exg93d" />
          </span>
        </motion.div>
        <p className="mt-8 text-[10px] font-extrabold uppercase tracking-[.2em] text-brand-success" data-id="element-698" data-mp="18bmeadv0lym6">Confirmed by you</p>
        <h1 className="mt-3 text-[31px] font-extrabold tracking-[-.05em] text-brand-navy" data-id="element-699" data-mp="13e43sj1cnbc2">{payment.isBill ? `${payment.bill} paid` : 'Transfer complete'}</h1>
        <p className="mt-2 text-sm text-brand-slate" data-id="element-700" data-mp="1w1qiamc480dp">₦{payment.amount} has been debited from your VE Bank Account.</p>

        <article className="mt-8 rounded-[28px] bg-white p-5 text-left shadow-float" data-id="element-701" data-mp="1r244aaogqg3u">
          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-702" data-mp="1n120dgjlpfvj">
            <div data-id="element-703" data-mp="fni8lscg1ljh">
              <p className="text-[10px] font-extrabold uppercase tracking-[.14em] text-brand-slate" data-id="element-704" data-mp="fo01cezwdhmn">Receipt</p>
              <p className="mt-1 text-sm font-extrabold text-brand-navy" data-id="element-705" data-mp="bln4yh71iw2j">VEB-84729104</p>
            </div>
            <span className="rounded-xl bg-brand-cloud px-3 py-2 text-[10px] font-extrabold text-brand-cobalt" data-id="element-706" data-mp="d43nrw08q0cb">SUCCESS</span>
          </div>
          <dl className="mt-4 space-y-3" data-id="element-707" data-mp="i02h7y0fe8jl">
            <Receipt label="Date and time" value="25 Jul 2026 · 09:42" data-id="element-708" data-mp="35e7g7nzsny6" />
            <Receipt label="From" value="VE Bank Account" data-id="element-709" data-mp="83z6i3rid1l1" />
            <Receipt label="To" value={payment.isBill ? payment.party : `${payment.party} · ${payment.account}`} data-id="element-710" data-mp="82e9m7hq16k0" />
            {!payment.isBill && <Receipt label="Bank" value={payment.bank} data-id="element-711" data-mp="3qg43lksgpp2c" />}
            <Receipt label="Narration" value={payment.narration} data-id="element-712" data-mp="3v9gllc2myxm4" />
            <Receipt label="Fee" value="₦0.00" data-id="element-713" data-mp="3gkaphwz3hnig" />
            <Receipt label="Total debit" value={`₦${payment.amount}`} strong data-id="element-714" data-mp="3gllug04a11b5" />
          </dl>
        </article>
      </section>

      <footer className="space-y-3 border-t border-slate-200 bg-white p-5" data-id="element-715" data-mp="37j2tjlk1wyrj">
        <button onClick={() => setSaved(true)} className="flex min-h-[50px] w-full items-center justify-center rounded-2xl bg-brand-cloud text-sm font-extrabold text-brand-navy" data-id="element-716" data-mp="37l78cyjhni6l">
          {saved ? 'Receipt saved to this device' : 'Save receipt'}
        </button>
        <button onClick={() => navigate('/home')} className="flex min-h-[54px] w-full items-center justify-center rounded-2xl bg-brand-navy text-sm font-extrabold text-white" data-id="element-717" data-mp="2nycdb5fuiycu">Done</button>
        <button onClick={() => navigate('/history')} className="min-h-[44px] w-full text-sm font-extrabold text-brand-cobalt" data-id="element-718" data-mp="2wxpnk0bsnqym">View transaction history</button>
      </footer>
    </main>;
}
function Receipt({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="flex justify-between gap-4" data-id="element-719" data-mp="3kmic3bq36wj7">
      <dt className="text-xs font-bold text-brand-slate" data-id="element-720" data-mp="3kpecd6pepxat">{label}</dt>
      <dd className={`text-right text-xs ${strong ? 'font-extrabold text-brand-cobalt' : 'font-bold text-brand-navy'}`} data-id="element-721" data-mp="3gmi0rzyab1gd">{value}</dd>
    </div>;
}